<template>
  <div id="app">
    <keep-alive :include="keepAliveList">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
// util
import { mapActions, mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';

export default {
  name: 'App',
  data() {
    return {
    }
  },
  computed: {
    ...mapState(useGlobalStore, ['keepAliveList'])
  },
  created() {
    // 初始化状态栏高度
    this.initStatusBarHeight();
  },
  methods: {
    ...mapActions(useGlobalStore, ['setStatusBarHeight']),
    
    /**
     * 初始化状态栏高度
     * 支持多种获取方式，确保所有机型都能正常显示
     */
    initStatusBarHeight() {
      console.log('开始初始化状态栏高度...');
      console.log('当前环境:', {
        inDjxApp: this.$env.inDjxApp,
        inIos: this.$env.inIos,
        inAndroid: this.$env.inAndroid
      });
      
      if (this.$env.inDjxApp) {
        // 在 App 内，尝试从原生获取
        this.getStatusBarHeightFromNative();
      } else {
        // 在浏览器中，使用 CSS 环境变量或默认值
        this.getStatusBarHeightFromCSS();
      }
    },
    
    /**
     * 从原生 App 获取状态栏高度
     */
    getStatusBarHeightFromNative() {
      // 将设置状态栏高度的方法挂载到window对象上，让iOS原生App调用
      window.setStatusBarHeight = (height) => {
        console.log('iOS原生回调状态栏高度:', height);
        if (height) {
          this.setStatusBarHeight(+height);
        }
        // 使用完后删除window上的setStatusBarHeight方法
        delete window.setStatusBarHeight;
      };
      
      if (this.$env.inAndroid) {
        // Android 同步获取状态栏高度
        try {
          const height = window.JSInterface.getStatusBarHeight();
          console.log('Android获取状态栏高度:', height);
          if (height) {
            this.setStatusBarHeight(+height);
          } else {
            console.warn('Android未返回状态栏高度，使用默认值');
            this.getStatusBarHeightFromCSS();
          }
        } catch (error) {
          console.error('Android获取状态栏高度失败:', error);
          this.getStatusBarHeightFromCSS();
        }
      } else if (this.$env.inIos) {
        // iOS 异步获取状态栏高度
        try {
          window.webkit.messageHandlers.getStatusBarHeight.postMessage(null);
          console.log('已请求iOS状态栏高度');
          
          // 设置超时降级处理
          setTimeout(() => {
            if (!window.setStatusBarHeight) {
              console.warn('iOS未返回状态栏高度，使用CSS环境变量或默认值');
              this.getStatusBarHeightFromCSS();
            }
          }, 1000);
        } catch (error) {
          console.error('iOS获取状态栏高度失败:', error);
          this.getStatusBarHeightFromCSS();
        }
      }
    },
    
    /**
     * 从 CSS 环境变量获取状态栏高度（降级方案）
     */
    getStatusBarHeightFromCSS() {
      console.log('尝试从CSS环境变量获取状态栏高度...');
      
      // 尝试从 CSS 环境变量获取 safe-area-inset-top
      const root = document.documentElement;
      
      // 设置 CSS 变量用于计算
      root.style.setProperty('--status-bar-height-test', 'env(safe-area-inset-top, 0px)');
      
      setTimeout(() => {
        const computed = getComputedStyle(root).getPropertyValue('--status-bar-height-test');
        const height = parseInt(computed);
        
        if (!isNaN(height) && height > 0) {
          console.log('从CSS环境变量获取到状态栏高度:', height);
          this.setStatusBarHeight(height);
        } else {
          console.log('CSS环境变量未返回有效值，保持当前默认值');
          // 保持 store 中已设置的智能默认值
        }
      }, 100);
    }
  }
}

</script>


<style>
  /* 定义 CSS 环境变量，支持安全区域 */
  :root {
    --safe-area-inset-top: env(safe-area-inset-top);
    --safe-area-inset-bottom: env(safe-area-inset-bottom);
    --safe-area-inset-left: env(safe-area-inset-left);
    --safe-area-inset-right: env(safe-area-inset-right);
  }
  
  html,body {
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 0;
    font-family: HiraginoSansGB, HiraginoSansGB;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  #app {
    min-height: 100vh;
    background-color: white;
  }
  html * {
    margin: 0;
    padding: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  em,
  i {
    font-style: normal;
  }
  ul,
  ol,
  li {
    list-style: none;
  }
  .write-off .el-input__inner {
    border: none !important;
    background: none !important;
  }
  .van-picker__title {
  display: none !important;
}
.van-picker__toolbar {
  background-color: #F9FAFB !important;
  height: 60px !important;
  font-size: 18px !important;
}

.van-picker__confirm {
  color:#00C275 !important;
  font-size: 18px !important;
}
.van-picker-column__item--selected {
  color:#00C275 !important;
}
.van-picker-column__item {
  font-size: 16px !important;
}
.van-picker__cancel {
  color:#666F83;
  font-size: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue